module.exports = __webpack_public_path__ + "img/SL-pin.00a2679f.png";